// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown, { ChevronDownOffset } from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

const borderWidth = "2px";
const borderRadius = pxToRem(8);

const iconStyles = () => {
    return css`
        ${iconScalableStyles(pxToRem(24), PlusOffset)}
        overflow: visible;
        height: 1em;
        margin-left: 0.25em;
    `;
};
/* Store Custom Code - End */

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles(true) /* Store Custom Code */};
        background-color: ${getColor("primary") /* Store Custom Code */};
        border: ${borderWidth} solid transparent; /* Store Custom Code */
        color: ${getColor("primary.contrast") /* Store Custom Code */};
        transition: ${transitionHoverStyles("background-color", "color", "border-color")};
        /* Store Custom Code - Start */
        border-radius: ${borderRadius};
        /* Store Custom Code - End */

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            font-size: ${theme.design.typography.size.base};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            background-color: ${getColor("primary") /* Store Custom Code */};
            border-color: ${getColor("transparent") /* Store Custom Code */};
            /* Store Custom Code - Start */
            color: ${getColor("primary.contrast")};
            /* Store Custom Code - End */
        }

        &:hover {
            color: ${getColor("primary.contrast") /* Store Custom Code */};
            /* Store Custom Code - Start */
            background-color: ${getColor("primary.light")};
            /* Store Custom Code - End */
        }

        ${breakpoint("lg")} {
            font-size: ${x => x.theme.design.typography.size.large};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

const accordion: Styleguide["accordion"] = {
    sectionDefaultProps: {
        headerProps: {
            css: css`
                ${_headerButtonStyles()}

                ${AccordionSectionPanel} + && {
                    ${_headerButtonStyles()}
                    ${({ theme }) => css`
                        ${breakpointValues(theme.design.accordion.spacing, "margin-top")}
                    `}
                }

                ${AccordionStyle} + ${AccordionStyle} && {
                    &:first-of-type {
                        ${({ theme }) => css`
                            ${breakpointValues(theme.design.accordion.spacing, "margin-top")}
                        `}
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                ${({ theme }) => css`
                    ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                    ${breakpointValues(theme.design.accordion.padding.vertical, "padding-top")}
                `}
                background-color: ${getColor("common.background")};
                border: ${borderWidth} solid transparent; /* Store Custom Code */
                border-top: none;
                /* Store Custom Code - Start */
                border-bottom-left-radius: ${borderRadius};
                border-bottom-right-radius: ${borderRadius};
                /* Store Custom Code - End */
            `,
        },
        toggleIconProps: {
            src: ChevronDown,
            color: "inherit",
            css: css`
                ${iconScalableStyles("1.2em", ChevronDownOffset)}
                margin-left: 1em;
            `,
        },
        titleTypographyProps: null as any,
        toggleTransition: {
            transitionCss: css`
                transition: none;
                bottom: auto;
            `,
            timeout: { enter: 0, exit: 0 },
        },
        /* Store Custom Code - Start */
        collapseIconProps: {
            src: Minus,
            color: "inherit",
            css: iconStyles(),
        },
        expandIconProps: {
            src: Plus,
            color: "inherit",
            css: iconStyles(),
        },
        /* Store Custom Code - End */
    },
};

export default accordion;
